import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import CameraEvent from './camera-event';
import CameraEventDetail from './camera-event-detail';

const Routes = ({ match }) => (
  <Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:hatDeviceCode/:hatEventId`} component={CameraEventDetail} />
    <ErrorBoundaryRoute path={match.url} component={CameraEvent} />
  </Switch>
);

export default Routes;
